import React from "react";
import {
  FaBalanceScale,
  FaHandshake,
  FaGavel,
  FaShieldAlt,
} from "react-icons/fa";
// Background image use karein jo professional courtroom ya library feel de
import courtroomBg from "../../assets/images/Herosection/herobanner.jpg";

const WhyChooseUs = () => {
  const brandGold = "#E3B66B";
  const charcoal = "#0F0F0F";

  const pillars = [
    {
      title: "19+ Years of Mastery",
      desc: "A legacy of transparency and results-driven advocacy in Delhi's highest courts.",
      icon: <FaBalanceScale />,
    },
    {
      title: "Client-First Ethics",
      desc: "Every legal strategy is crafted with precision, keeping your peace of mind as the priority.",
      icon: <FaHandshake />,
    },
    {
      title: "Strategic Litigation",
      desc: "From first consultation to final outcome, providing consistent courtroom clarity.",
      icon: <FaShieldAlt />,
    },
    {
      title: "Dedicated Advocacy",
      desc: "Specialized expertise across civil, criminal, corporate, and matrimonial legal matters.",
      icon: <FaGavel />,
    },
  ];

  return (
    <section className="relative font-sans bg-white">
      {/* --- HERO SECTION: ADVOCATE BRANDING --- */}
      <div
        className="relative py-28 lg:py-36 px-6"
        style={{ backgroundColor: charcoal }}
      >
        <div className="absolute inset-0 z-0 opacity-20">
          <img
            src={courtroomBg}
            alt="Law Office"
            className="w-full h-full object-cover grayscale"
          />
        </div>

        <div className="max-w-7xl mx-auto relative z-10 text-center">
          <span
            className="uppercase tracking-[0.5em] text-[10px] font-bold mb-4 block"
            style={{ color: brandGold }}
          >
            Advocate & Legal Consultant
          </span>
          <h2 className="text-4xl md:text-6xl text-white font-serif mb-6 leading-tight">
            Why Clients Choose <br />
            <span className="italic font-light" style={{ color: brandGold }}>
              Adv. Akash Giri
            </span>
          </h2>
          <div className="w-20 h-[1px] bg-white/20 mx-auto mb-8"></div>
          <p className="max-w-2xl mx-auto text-gray-400 font-light text-lg leading-relaxed">
            Providing strategic legal solutions with a commitment to integrity,
            excellence, and personalized attention for every complex case.
          </p>
        </div>
      </div>

      {/* --- FLOATING PILLARS SECTION --- */}
      <div className="relative px-6 pb-28 bg-white">
        <div className="max-w-7xl mx-auto -mt-20 relative z-20">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {pillars.map((item, index) => (
              <div
                key={index}
                className="bg-white p-10 group shadow-[0_15px_50px_rgba(0,0,0,0.05)] rounded-xl transition-all duration-500 hover:-translate-y-4 border-b-4 border-transparent hover:border-[#E3B66B] hover:bg-[#0F0F0F]"
              >
                {/* Icon */}
                <div
                  className="text-4xl mb-8 transition-all duration-500 group-hover:scale-110 group-hover:rotate-3"
                  style={{ color: brandGold }}
                >
                  {item.icon}
                </div>

                {/* Title - group-hover use kiya hai taaki parent hover par white ho jaye */}
                <h4 className="text-xl font-bold text-[#1A1A1A] mb-4 font-serif tracking-tight transition-colors duration-500 group-hover:text-white">
                  {item.title}
                </h4>

                {/* Description - text-gray-500 se white/text-gray-300 transition */}
                <p className="text-gray-500 text-sm leading-relaxed transition-colors duration-500 group-hover:text-gray-300">
                  {item.desc}
                </p>

                {/* Small accent line that appears on hover */}
                <div className="mt-6 w-0 h-[1px] bg-[#E3B66B] transition-all duration-500 group-hover:w-12"></div>
              </div>
            ))}
          </div>
        </div>

        {/* --- PROFESSIONAL CTA SECTION --- */}
        <div className="mt-32 max-w-5xl mx-auto bg-[#161616] rounded-[2rem] overflow-hidden relative shadow-2xl">
          {/* Decorative Subtle Pattern */}
          <div className="absolute inset-0 opacity-5 pointer-events-none">
            <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(#E3B66B_1px,transparent_1px)] [background-size:20px_20px]"></div>
          </div>

          <div className="relative z-10 p-12 md:p-20 text-center">
            <h3 className="text-3xl md:text-5xl font-serif text-white mb-8">
              Discuss Your Case <br className="hidden md:block" />
              With <span style={{ color: brandGold }}>Adv. Akash Giri</span>
            </h3>

            <p className="text-gray-400 mb-12 max-w-xl mx-auto font-light leading-relaxed">
              Don't navigate legal complexities alone. Get expert guidance and
              protect your rights with a confidential consultation.
            </p>

            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <a
                href="/contact-us"
                className="px-12 py-5 font-bold tracking-widest uppercase text-[11px] transition-all duration-500"
                style={{ backgroundColor: brandGold, color: charcoal }}
              >
                Book a Consultation
              </a>
              <a
                href="tel:+91..."
                className="px-12 py-5 font-bold tracking-widest uppercase text-[11px] text-white border border-white/20 hover:border-[#E3B66B] hover:text-[#E3B66B] transition-all duration-500"
              >
                Call Office
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
